import { render, staticRenderFns } from "./StockItemPrice.vue?vue&type=template&id=0321cfc8&scoped=true&"
import script from "./StockItemPrice.vue?vue&type=script&lang=js&"
export * from "./StockItemPrice.vue?vue&type=script&lang=js&"
import style0 from "./StockItemPrice.vue?vue&type=style&index=0&id=0321cfc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321cfc8",
  null
  
)

export default component.exports